/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { TOGGLE_MENU, CLOSE_MENU } from '../actions'


/*********************************************************************************
 2. Reducers
 *********************************************************************************/

export const initialState = {
    isNavigationOpen: false
};

export const App = (state = initialState, { type }) => {
    switch (type) {
        case TOGGLE_MENU:
            return {
                ...state,
                isNavigationOpen: !state.isNavigationOpen
            };
        case CLOSE_MENU:
            return {
                ...state,
                isNavigationOpen: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/index.js